import { Layout, PaginationType } from '@wix/communities-blog-client-common';
import { VideoPlayType } from '@app/common/settings-components/types';

export const LAYOUT_TYPE_AI_DESCRIPTION = `
        The layout type for the blog feed page.
        Possible values:
        - ${Layout.PgSideBySide} Image on one side, content on the other side.
        - ${Layout.PgGrid} Grid layout.
        - ${Layout.PgCardMedium} Tiled layout where each card has it's own size.
        - ${Layout.PgTextOnImageMedium} Magazine layout where text is on the image.
        - ${Layout.PgOneColumn} One column layout.
        `;

export const PAGINATION_TYPE_AI_DESCRIPTION = `
        The pagination type for the blog feed page.
        Possible values:
        - ${PaginationType.InfiniteScroll} Infinite scroll.
        - ${PaginationType.MultiplePages} Multiple pages.
        `;

export const VIDEO_PLAY_TYPE_AI_DESCRIPTION = `
        The video play type for the blog feed page.
        Possible values:
        - ${VideoPlayType.OnHover} On hover.
        - ${VideoPlayType.Autoplay} Autoplay.
        - ${VideoPlayType.OnClick} On click.
        `;
